import i18n from "../i18n";

const Nutrition = (app) => {
  app
    // Create or update a nutrition plan
    .post(
      "/nutrition/save/:plan?",
      async ({ req, res, flash, api, locals }) => {
        const { body, params, query = {} } = req;
        const { proxyAthlete } = query;
        const { plan } = params;

        if (!plan) {
          body.coachId = locals.activeUserToRequest._id;
          await api(`nutrition-plan/?proxyAthlete=${proxyAthlete}`, {
            method: "POST",
            body,
          });
          flash("success", i18n.t("coaching-portal:nutritionActions.successfullyCreated"));
        } else {
          if (!body.restDay) {
            body.restDay = null;
          }

          await api(`nutrition-plan/${plan}/?proxyAthlete=${proxyAthlete}`, {
            method: "PUT",
            body,
          });
          flash("success", i18n.t("coaching-portal:nutritionActions.successfullyUpdated"));
        }

        res.refreshWith(
          { modal: "", plan: "", copy: "" },
          { url: "back", hash: "#_" }
        );
      }
    )
    .get(
      "/nutrition/delete-nutrition-plan/:_id/:mealPlanId?",
      async ({ req, res, flash, api }) => {
        const { params, query = {} } = req;
        const { proxyAthlete } = query;
        const { _id, mealPlanId = null } = params;

        const hasMealPlan = mealPlanId && mealPlanId !== "null";
        const confirmDelete = hasMealPlan
          ? i18n.t("coaching-portal:nutritionActions.confirmDeleteWithMealPlan")
          : i18n.t("coaching-portal:nutritionActions.confirmDelete");

        if (process.browser && !confirm(confirmDelete)) {
          return res.backDontScroll();
        }

        await api(
          `nutrition-plan/${_id}?proxyAthlete=${proxyAthlete}&mealPlanId=${mealPlanId}`,
          {
            method: "DELETE",
          }
        );
        flash("success", i18n.t("coaching-portal:nutritionActions.successfullyDeleted"));

        res.backDontScroll();
      }
    );
};

export default Nutrition;
